/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export { ApiConfiguration } from './api-configuration';
export { ApiBaseService } from './api-base-service';
export { RequestBuilder } from './request-builder';
export { StrictHttpResponse } from './strict-http-response';
export { ApiClientModule } from './api-client.module';
export { ActivateRewardRequest } from './models/activate-reward-request';
export { AllergenEnum } from './models/allergen-enum';
export { AppError } from './models/app-error';
export { ArticleDateLimitExceededExceptionPayload } from './models/article-date-limit-exceeded-exception-payload';
export { ArticleMaxQuantityByDishFamilyExceededPayload } from './models/article-max-quantity-by-dish-family-exceeded-payload';
export { ArticleMaxQuantityExceededPayload } from './models/article-max-quantity-exceeded-payload';
export { AuthTokenDto } from './models/auth-token-dto';
export { BookingDto } from './models/booking-dto';
export { CartFormulaDishDto } from './models/cart-formula-dish-dto';
export { CartFormulaDto } from './models/cart-formula-dto';
export { CartItemDto } from './models/cart-item-dto';
export { ChangePasswordRequest } from './models/change-password-request';
export { ChangePasswordResult } from './models/change-password-result';
export { ChatDto } from './models/chat-dto';
export { ChatMessageDto } from './models/chat-message-dto';
export { ChatMessageSenderDto } from './models/chat-message-sender-dto';
export { ChatMessageSenderTypes } from './models/chat-message-sender-types';
export { ChatTypes } from './models/chat-types';
export { CheckCartRequest } from './models/check-cart-request';
export { CheckCartResult } from './models/check-cart-result';
export { CheckEmailForAuthenticationRequest } from './models/check-email-for-authentication-request';
export { CheckEmailForAuthenticationResult } from './models/check-email-for-authentication-result';
export { Civilite } from './models/civilite';
export { ConfirmEmailRequest } from './models/confirm-email-request';
export { ConviveTypeContrat } from './models/convive-type-contrat';
export { CreateOrderRequest } from './models/create-order-request';
export { CreateOrderResult } from './models/create-order-result';
export { CreditExceptionPayload } from './models/credit-exception-payload';
export { DateOnlyDto } from './models/date-only-dto';
export { DayOfWeek } from './models/day-of-week';
export { DeleteBookingRequest } from './models/delete-booking-request';
export { DeleteNotificationRequest } from './models/delete-notification-request';
export { DeliveryLocationDto } from './models/delivery-location-dto';
export { DishCaloriesDto } from './models/dish-calories-dto';
export { DishDto } from './models/dish-dto';
export { DishFamilyDto } from './models/dish-family-dto';
export { DtaOrderDto } from './models/dta-order-dto';
export { EnqueteType } from './models/enquete-type';
export { EnsureEmailValidityRequest } from './models/ensure-email-validity-request';
export { EnsureEmailValidityWithSsoResult } from './models/ensure-email-validity-with-sso-result';
export { FaqCategory } from './models/faq-category';
export { FaqQuestion } from './models/faq-question';
export { FluiditeRateDto } from './models/fluidite-rate-dto';
export { FluiditeTauxOccupationValues } from './models/fluidite-taux-occupation-values';
export { ForgotPasswordRequest } from './models/forgot-password-request';
export { FormulaDto } from './models/formula-dto';
export { GetAccountBalanceResult } from './models/get-account-balance-result';
export { GetAnimationsResult } from './models/get-animations-result';
export { GetBookingLieuResult } from './models/get-booking-lieu-result';
export { GetBookingResult } from './models/get-booking-result';
export { GetBookingsResult } from './models/get-bookings-result';
export { GetChatResult } from './models/get-chat-result';
export { GetChatsResult } from './models/get-chats-result';
export { GetCurrentFluiditeResult } from './models/get-current-fluidite-result';
export { GetExternalRestaurantHomeResult } from './models/get-external-restaurant-home-result';
export { GetFaqResult } from './models/get-faq-result';
export { GetFluiditeRatesResult } from './models/get-fluidite-rates-result';
export { GetNotificationSettingsResult } from './models/get-notification-settings-result';
export { GetNotificationsResult } from './models/get-notifications-result';
export { GetOrderResult } from './models/get-order-result';
export { GetOrdersResult } from './models/get-orders-result';
export { GetOrdersResultExternal } from './models/get-orders-result-external';
export { GetOrdersResultList } from './models/get-orders-result-list';
export { GetOrdersSummaryResult } from './models/get-orders-summary-result';
export { GetRegistrationSiteResult } from './models/get-registration-site-result';
export { GetRegistrationSitesResult } from './models/get-registration-sites-result';
export { GetReloadAccountBalanceConfigResult } from './models/get-reload-account-balance-config-result';
export { GetRestaurantMenusResult } from './models/get-restaurant-menus-result';
export { GetRestaurantsResult } from './models/get-restaurants-result';
export { GetRewardsCatalogResult } from './models/get-rewards-catalog-result';
export { GetSlotsResult } from './models/get-slots-result';
export { GetSurveyChatResult } from './models/get-survey-chat-result';
export { GetSurveyChatsResult } from './models/get-survey-chats-result';
export { GetSurveyResult } from './models/get-survey-result';
export { GetTicketPdfRequest } from './models/get-ticket-pdf-request';
export { GetTicketsBatchPdfRequest } from './models/get-tickets-batch-pdf-request';
export { GetTicketsResult } from './models/get-tickets-result';
export { GetUnreadChatsCountResult } from './models/get-unread-chats-count-result';
export { GetUnreadNotificationsCountResult } from './models/get-unread-notifications-count-result';
export { GetUserInfoResult } from './models/get-user-info-result';
export { GetUserLikesResult } from './models/get-user-likes-result';
export { GetUserLoyaltyEventsResult } from './models/get-user-loyalty-events-result';
export { GetUserPointsResult } from './models/get-user-points-result';
export { GetUserRewardsResult } from './models/get-user-rewards-result';
export { IErrorPayload } from './models/i-error-payload';
export { JwtBearerUnauthorizedPayload } from './models/jwt-bearer-unauthorized-payload';
export { LieuDto } from './models/lieu-dto';
export { LikesDto } from './models/likes-dto';
export { LoginWithJsonWebTokenRequest } from './models/login-with-json-web-token-request';
export { LoginWithJsonWebTokenResult } from './models/login-with-json-web-token-result';
export { LoginWithPasswordRequest } from './models/login-with-password-request';
export { LoginWithPasswordResult } from './models/login-with-password-result';
export { LoginWithSamlRequest } from './models/login-with-saml-request';
export { LoginWithSamlResult } from './models/login-with-saml-result';
export { LoginWithSsoRequest } from './models/login-with-sso-request';
export { LoginWithSsoResult } from './models/login-with-sso-result';
export { LoyaltyEventDto } from './models/loyalty-event-dto';
export { MaxDishInFormulaSectionExceededPayload } from './models/max-dish-in-formula-section-exceeded-payload';
export { MaxFormulasAllowedExceededPayload } from './models/max-formulas-allowed-exceeded-payload';
export { MenuDto } from './models/menu-dto';
export { MinDishInFormulaSectionNotMetPayload } from './models/min-dish-in-formula-section-not-met-payload';
export { MobilePlatform } from './models/mobile-platform';
export { ModelStateErrorEntry } from './models/model-state-error-entry';
export { ModelStateErrorPayload } from './models/model-state-error-payload';
export { NavbarPosition } from './models/navbar-position';
export { NoteDto } from './models/note-dto';
export { NotificationDto } from './models/notification-dto';
export { NotificationParameterFlags } from './models/notification-parameter-flags';
export { NotificationSettingsByFlag } from './models/notification-settings-by-flag';
export { NotificationType } from './models/notification-type';
export { NutritionnalValue } from './models/nutritionnal-value';
export { NutritionnalValueTypeEnum } from './models/nutritionnal-value-type-enum';
export { NutritionnalValueUnitEnum } from './models/nutritionnal-value-unit-enum';
export { OrderArticleDto } from './models/order-article-dto';
export { OrderDto } from './models/order-dto';
export { OrderPriceDto } from './models/order-price-dto';
export { OrderRestaurantDto } from './models/order-restaurant-dto';
export { OrderSettingsDto } from './models/order-settings-dto';
export { OrderSummaryDto } from './models/order-summary-dto';
export { PaymentErrorResultEnum } from './models/payment-error-result-enum';
export { PaymentProviderDto } from './models/payment-provider-dto';
export { PaymentProviderEnum } from './models/payment-provider-enum';
export { PaymentRedirectionDto } from './models/payment-redirection-dto';
export { PaymentTypeValues } from './models/payment-type-values';
export { PreparationStatutCommandes } from './models/preparation-statut-commandes';
export { ProviderInfo } from './models/provider-info';
export { RedeemRewardRequest } from './models/redeem-reward-request';
export { RedeemRewardResult } from './models/redeem-reward-result';
export { RefreshTokenRequest } from './models/refresh-token-request';
export { RefreshTokenResult } from './models/refresh-token-result';
export { RegisterAmbigousAccountDto } from './models/register-ambigous-account-dto';
export { RegisterDeviceRequest } from './models/register-device-request';
export { RegisterRequest } from './models/register-request';
export { RegisterResult } from './models/register-result';
export { RegisterScenarioEnum } from './models/register-scenario-enum';
export { RegistrationCguDto } from './models/registration-cgu-dto';
export { RegistrationSiteDto } from './models/registration-site-dto';
export { ReloadAccountBalanceRequest } from './models/reload-account-balance-request';
export { ReloadAccountBalanceResult } from './models/reload-account-balance-result';
export { ReloadAmountWithPoints } from './models/reload-amount-with-points';
export { ReplyToChatRequest } from './models/reply-to-chat-request';
export { ReplyToChatResponse } from './models/reply-to-chat-response';
export { ReplyToSurveyRequest } from './models/reply-to-survey-request';
export { ResetPasswordRequest } from './models/reset-password-request';
export { RestaurantAnimationDto } from './models/restaurant-animation-dto';
export { RestaurantContactDto } from './models/restaurant-contact-dto';
export { RestaurantDisplaySettings } from './models/restaurant-display-settings';
export { RestaurantDto } from './models/restaurant-dto';
export { RestaurantServiceValues } from './models/restaurant-service-values';
export { RestaurantSousTypeValues } from './models/restaurant-sous-type-values';
export { RestaurantTypeValues } from './models/restaurant-type-values';
export { RewardDto } from './models/reward-dto';
export { RewardFamilyDto } from './models/reward-family-dto';
export { SaveBookingEventsSaved } from './models/save-booking-events-saved';
export { SaveBookingRequest } from './models/save-booking-request';
export { SaveBookingResult } from './models/save-booking-result';
export { SaveBookingStatus } from './models/save-booking-status';
export { ScorpOrderDto } from './models/scorp-order-dto';
export { SectionDto } from './models/section-dto';
export { SendConfirmEmailRequest } from './models/send-confirm-email-request';
export { SetChatsAsReadRequest } from './models/set-chats-as-read-request';
export { SetNotificationsAsReadRequest } from './models/set-notifications-as-read-request';
export { SlotDto } from './models/slot-dto';
export { StatutCommandes } from './models/statut-commandes';
export { StringStringKeyValuePair } from './models/string-string-key-value-pair';
export { SurveyCampaignDto } from './models/survey-campaign-dto';
export { SurveyChatPayloadDto } from './models/survey-chat-payload-dto';
export { SurveyQuestionDto } from './models/survey-question-dto';
export { SurveyReplyDto } from './models/survey-reply-dto';
export { TestSebSender } from './models/test-seb-sender';
export { TicketClientDataDto } from './models/ticket-client-data-dto';
export { TicketDto } from './models/ticket-dto';
export { TicketItemDto } from './models/ticket-item-dto';
export { TicketLegalDataDto } from './models/ticket-legal-data-dto';
export { TicketPriceDto } from './models/ticket-price-dto';
export { ToggleUserLoyaltyRequest } from './models/toggle-user-loyalty-request';
export { ToggleUserLoyaltyResult } from './models/toggle-user-loyalty-result';
export { TypeNotification } from './models/type-notification';
export { TypologyDto } from './models/typology-dto';
export { UnregisterDeviceRequest } from './models/unregister-device-request';
export { UpdateAccountInfosRequest } from './models/update-account-infos-request';
export { UpdateAccountInfosResult } from './models/update-account-infos-result';
export { UpdateBalanceAlertRequest } from './models/update-balance-alert-request';
export { UpdateDishLikeNotificationBodyRequest } from './models/update-dish-like-notification-body-request';
export { UpdateDishLikesBodyRequest } from './models/update-dish-likes-body-request';
export { UpdateEmailRequest } from './models/update-email-request';
export { UpdateEmailResult } from './models/update-email-result';
export { UpdateNotificationSettingsRequest } from './models/update-notification-settings-request';
export { UpdateOptInSettingsRequest } from './models/update-opt-in-settings-request';
export { UpdatePreferredLanguageRequest } from './models/update-preferred-language-request';
export { UpdateTableNumberBodyRequest } from './models/update-table-number-body-request';
export { UserInfoDto } from './models/user-info-dto';
export { UserLikesDishDto } from './models/user-likes-dish-dto';
export { UserLikesDishFamilyDto } from './models/user-likes-dish-family-dto';
export { UserLoyaltyInfoDto } from './models/user-loyalty-info-dto';
export { UserRewardDto } from './models/user-reward-dto';
export { UserRewardStatus } from './models/user-reward-status';
export { UserSiteInfoDto } from './models/user-site-info-dto';
export { ApiAuthenticationService } from './services/api-authentication.service';
export { ApiBookingsService } from './services/api-bookings.service';
export { ApiChatsService } from './services/api-chats.service';
export { ApiDocumentsService } from './services/api-documents.service';
export { ApiFaqService } from './services/api-faq.service';
export { ApiLoyaltyService } from './services/api-loyalty.service';
export { ApiNotificationsService } from './services/api-notifications.service';
export { ApiOrdersService } from './services/api-orders.service';
export { ApiPaymentsService } from './services/api-payments.service';
export { ApiRegistrationService } from './services/api-registration.service';
export { ApiRestaurantsService } from './services/api-restaurants.service';
export { ApiSurveysService } from './services/api-surveys.service';
export { ApiTestsService } from './services/api-tests.service';
export { ApiTicketsService } from './services/api-tickets.service';
